import { create } from 'zustand';
import type { CustomAlarmCodeOverride } from '../data/overridesRuntime';
import { fetchAndApplyOverrides } from '../data/refreshOverrides';

/**
 * customAlarmCodeDraft — dar de alta o quitar un código de alarma propio de
 * este municipio (SC-43, ej. "ventilador roto"). Guardado directo, mismo
 * patrón que el resto de Modo Edición — sin estado propio, tras cada
 * escritura se vuelve a pedir `GET /api/overrides` completo.
 */
export type { CustomAlarmCodeOverride } from '../data/overridesRuntime';

interface DraftState {
  saving: boolean;
  stage: (d: CustomAlarmCodeOverride) => Promise<boolean>;
  remove: (code: string) => Promise<boolean>;
}

export const useCustomAlarmCodeDraft = create<DraftState>((set) => ({
  saving: false,
  stage: async (d) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/alarm_code/${encodeURIComponent(d.code)}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d),
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
  remove: async (code) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/alarm_code/${encodeURIComponent(code)}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!res.ok && res.status !== 404) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
}));
